var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"m0 8 1.5 1.5L7 4v12h2V4l5.5 5.5L16 8 8 0z"}));
}

ArrowUp.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
